import React from 'react';
import { Route, RouteProps, Redirect } from 'react-router-dom';
import { observer, Observer } from 'mobx-react';
import { useStore } from '../store/mst';
import LoadingLogo from '../components/loading/LoadingLogo';
import * as RoutePaths from './paths';

const ProtectedRoute: React.FunctionComponent<RouteProps> = ({ component: Component, ...rest }) => {
  const store = useStore();

  if (Component == null) {
    return null;
  }

  return (
    <Route
      {...rest}
      render={(props) => (
        <Observer>
          {() => {
            if (store.auth.isVerifying) {
              return <LoadingLogo />;
            }

            if (store.auth.isVerified && store.auth.userId) {
              // password was changed to temporary, user must login again and update
              if (store.account.user?.tempPassword && props.location.pathname !== RoutePaths.updatePasswordPath) {
                return <Redirect to={{ pathname: RoutePaths.loginPath, state: { redirectTo: props.location.pathname, queryParams: props.location.search } }} />;
              }

              // email verification required - redirect unverified users
              if (store.account.user?.verified === false) {
                return <Redirect to={{ pathname: RoutePaths.verifyEmailPath, state: { redirectTo: props.location.pathname, queryParams: props.location.search } }} />;
              }

              return <Component {...props} />;
            }
            return <Redirect to={{ pathname: RoutePaths.loginPath, state: { redirectTo: props.location.pathname, queryParams: props.location.search } }} />;
          }}
        </Observer>
      )}
    />
  );
};

export default observer(ProtectedRoute);
